export const SET_CURRENT_ONBOARDING_STEP = 'SET_CURRENT_ONBOARDING_STEP'
export const RESET_ONBOARDING = 'RESET_ONBOARDING'
export const SET_SIGNUP_PAYLOAD = 'SET_SIGNUP_PAYLOAD'
export const SET_SELECTED_THEMES_IDS = 'SET_SELECTED_THEMES_IDS'
